import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldType } from '@ngx-formly/core';
import { InfoTooltipComponent } from '../info-tooltip.component';

@Component({
  selector: 'formly-field-label',
  imports: [CommonModule, InfoTooltipComponent],
  template: `<label class="text-default">
    {{ props.label !== '' ? props.label : formControl.value }}
    <app-info-tooltip [tooltip]="props.info"></app-info-tooltip>
  </label>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyLabelComponent extends FieldType<any> {}
